/* eslint-disable import/no-named-as-default */
import { FC, ReactElement } from 'react'
import CookieConsent from 'react-cookie-consent'

import {
  defaultStyleClasses,
  defaultCookieProperties,
  defaultBannerContent,
  COOKIE_BANNER_OPTIONS,
  PRIVACY_POLICY_LINK,
  PRIVACY_POLICY,
} from '../../constants'
import { updateCookieBannerValue } from '../../features/appConfig/appConfigSlice'
import { useAppDispatch } from '../../store'
import { CookieBannerValue } from '../../types'
import './cookieBanner.css'

type bannerContent = {
  location?: COOKIE_BANNER_OPTIONS
  buttonText?: string
  cookieBannerMessage?: string
}

type styleClasses = {
  containerClasses?: string
  buttonClasses?: string
}

type cookieProperties = {
  cookieName?: string
  cookieValue: CookieBannerValue
  expires?: number
}
type CookieBannerProps = {
  bannerContent: bannerContent
  styleClasses: styleClasses
  cookieProperties: cookieProperties
}

const CookiesBanner: FC<CookieBannerProps> = (props): ReactElement => {
  const dispatch = useAppDispatch()
  const { bannerContent, styleClasses, cookieProperties } = props
  return (
    <div role="dialog" aria-label="cookie consent">
      <CookieConsent
        location={bannerContent.location}
        buttonText={bannerContent.buttonText}
        containerClasses={styleClasses.containerClasses}
        cookieName={cookieProperties.cookieName}
        cookieValue={cookieProperties.cookieValue}
        expires={cookieProperties.expires}
        buttonClasses={styleClasses.buttonClasses}
        onAccept={async () => await dispatch(updateCookieBannerValue(true))}
      >
        {bannerContent.cookieBannerMessage + ' '}
        <a href={PRIVACY_POLICY_LINK} rel="noreferrer">
          {PRIVACY_POLICY}
        </a>
      </CookieConsent>
    </div>
  )
}

CookiesBanner.defaultProps = {
  bannerContent: defaultBannerContent,
  styleClasses: defaultStyleClasses,
  cookieProperties: defaultCookieProperties,
}

export default CookiesBanner
